<template>
  <el-dialog
    append-to-body
    title="查看服务器"
    width="670px"
    @close="handleCancle"
    @closed="reset"
    :visible="visible"
  >
    <el-form v-loading="loading" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务器IP">
            <span>{{ serverDetail.serverIp }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务器端口">
            <span>{{ serverDetail.serverPort }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="负载状态">
            <span
              v-if="serverDetail.serverLoadStatus + ''"
              :class="loadTypeList[serverDetail.serverLoadStatus].class"
            >
              {{ loadTypeList[serverDetail.serverLoadStatus].type }}
            </span>
            <span v-else>{{ '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-table v-if="serverDetail.remark.length" :data="serverDetail.remark">
              <el-table-column align="center" label="名称" prop="name"> </el-table-column>
              <el-table-column align="center" label="值" prop="value"> </el-table-column>
            </el-table>
            <span v-else>{{ '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button type="primary" @click="handleCancle">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import { isEmpty } from 'lodash';
import deviceApi from 'api/home/device-mangement';
export default {
  data() {
    return {
      serverDetail: {
        serverIp: '',
        serverPort: '',
        serverLoadStatus: 0,
        remark: []
      },
      loadTypeList: {
        0: { type: '空闲', class: 'blue-col' },
        1: { type: '正常', class: 'green-col' },
        2: { type: '拥挤', class: 'yellow-col' },
        3: { type: '满载', class: 'red-col' }
      },
      visible: false,
      loading: false
    };
  },
  methods: {
    init(protocolVersionServerPortId) {
      this.visible = true;
      this.loading = true;
      deviceApi
        .getServeDetaiLByPortId({ protocolVersionServerPortId })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            this.visible = false;
            return;
          }
          this.serverDetail = {
            serverIp: data.serverIp,
            serverPort: data.serverPort,
            serverLoadStatus: data.serverLoadStatus,
            remark: JSON.parse(data.remark)
          };
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    reset() {
      this.serverDetail = {
        serverIp: '',
        serverPort: '',
        serverLoadStatus: 0,
        remark: []
      };
      this.loading = false;
    },
    handleCancle() {
      this.visible = false;
    }
  }
};
</script>